export default "__VITE_ASSET__eZhYokMK__"